module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-align-right-070bdc485b8d832a797fa3a63514886a.png";